<template>
<p>
This page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it.<br/>
Thank you.
</p>
</template>

<script>

export default {
  name: 'last',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_0a9fca13b620a2de592dddca89bae7c7_34PU7E.ch.fixed.fc.tidied.stylehacked.xfixed_split_028.vue?71f93ea0